import Collapse from './Collapse';

export default Collapse;
export var Panel = Collapse.Panel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-collapse@1.9.3@rc-collapse/es/index.js
// module id = 271
// module chunks = 0 1